import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../twc.refresh-layer-plugin.service';
import { WATER_VAPOR_LEGEND } from './water-vapor.legend';
import { WATER_VAPOR_PRODUCT_DATA } from './water-vapor.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class WaterVaporPluginService {
  private _twcPluginService = inject(TwcRefreshLayerPluginService);

  plugin$ = this._twcPluginService.create(WATER_VAPOR_PRODUCT_DATA, {
    legend: WATER_VAPOR_LEGEND,
    twcLayerTypes: ['web-tile']
  });
}
